import { render } from "./VerificationPage.vue?vue&type=template&id=42bba5db"
const script = {}

import exportComponent from "/workspace/src/services/admin/webapp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__